import { RouteItemId } from 'common/enums/html.enums';
import { Routes } from 'constants/route.constants';
import { ReactComponent as ClubsIcon } from 'img/icons/sidebar/dumbbell.svg';
import { ReactComponent as CorporationsIcon } from 'img/icons/sidebar/building.svg';
import { PoliciesPermissionSetItems as Permission } from 'common/constants/permissions';
import { RouteItem } from 'types/route.types';
import {
  employeesNavLink,
  membersNavLink,
  dictionaryNavLink,
  homeNavLink,
} from 'constants/routeItems/routeItemNavLink.constants';
import {
  bookingContainer,
  crmContainer,
  ptCrmContainer,
  timeclockContainer,
  daySheetContainer,
  reportsContainer,
  servicesContainer,
  posContentContainer,
  permissionsContainer,
  communicationContainer,
  clientAdjustmentsContainer,
} from 'constants/routeItems/routeItemContainer.constants';
import commonMessages from 'common/messages/messages';

export const corporationRouteItems: RouteItem[] = [
  homeNavLink,
  bookingContainer,
  crmContainer,
  ptCrmContainer,
  membersNavLink,
  employeesNavLink,
  timeclockContainer,
  daySheetContainer,
  reportsContainer,
  {
    type: 'groupTitle',
    id: 'corporationName',
    relatesTo: [
      servicesContainer.id,
      posContentContainer.id,
      dictionaryNavLink.id,
      permissionsContainer.id,
      RouteItemId.RouteItemBtnClubs,
      RouteItemId.RouteItemBtnCorporateSettings,
      communicationContainer.id,
    ],
  },
  servicesContainer,
  posContentContainer,
  dictionaryNavLink,
  permissionsContainer,
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnClubs,
    path: Routes.CLUBS,
    title: commonMessages.clubsLabel,
    icon: ClubsIcon,
    permissions: [Permission.CLIENT_LIST_VIEW],
  },
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnCorporateSettings,
    path: Routes.CORPORATE_SETTINGS,
    title: commonMessages.corporateSettings,
    icon: CorporationsIcon,
    permissions: [
      Permission.CORPORATE_GENERAL_INFO_VIEW,
      Permission.CORPORATE_BANK_INFO_VIEW,
      Permission.CORPORATE_BILLING_INFO_VIEW,
      Permission.CORPORATE_FEE_RATES_VIEW,
      Permission.CORPORATE_PROCESSOR_CONFIGURATION_VIEW,
      Permission.CORPORATE_TAXES_INFO_VIEW,
      Permission.CORPORATE_INTEGRATION_VIEW,
      Permission.CORPORATE_OTHER_INFO_VIEW,
      Permission.CORPORATE_REQUIRED_FIELDS_VIEW,
      Permission.CORPORATE_PAY_PERIOD_SETTINGS_VIEW,
    ],
  },
  communicationContainer,
  clientAdjustmentsContainer,
];
